import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: 'textarea[appAutoGrowHeight]',
})
export class AutoGrowHeightDirective {
  private readonly minHeight = 32; // Minimum height when empty
  private readonly maxHeight = 160; // Maximum height before scrolling

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('input') onInput() {
    this.resize();
  }

  // Public method to reset height (call this after sending message)
  public resetHeight() {
    const textarea = this.elementRef.nativeElement;
    this.renderer.setStyle(textarea, 'height', `${this.minHeight}px`);
    this.renderer.setStyle(textarea, 'overflow-y', 'hidden');
  }

  ngOnInit() {
    this.setInitialStyles();
    this.resetHeight(); // Start with minimum height
  }

  private setInitialStyles() {
    const textarea = this.elementRef.nativeElement;
    this.renderer.setStyle(textarea, 'resize', 'none');
    this.renderer.setStyle(textarea, 'overflow-y', 'hidden');
    this.renderer.setStyle(textarea, 'min-height', `${this.minHeight}px`);
    this.renderer.setStyle(textarea, 'transition', 'height 0.2s ease');
  }

  private resize() {
    const textarea = this.elementRef.nativeElement;

    // Reset height to calculate proper scrollHeight
    this.renderer.setStyle(textarea, 'height', 'auto');

    // Calculate new height (clamped between min and max)
    const newHeight = Math.min(Math.max(textarea.scrollHeight, this.minHeight), this.maxHeight);

    this.renderer.setStyle(textarea, 'height', `${newHeight}px`);

    // Only show scrollbar when at max height
    const shouldScroll = textarea.scrollHeight > this.maxHeight;
    this.renderer.setStyle(textarea, 'overflow-y', shouldScroll ? 'auto' : 'hidden');
  }
}
